import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionPalette = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"type": "page",
			"properties": {
				"title": [
					[
						"Палитра"
					]
				]
			},
			"content": [
				"72a6ab8e-c2e9-4dcc-b723-19f053f1beb1",
				"083121be-fff4-4b9a-8eae-e980db6982be",
				"b7d4eee9-afdb-40ee-bd87-391f3add4151",
				"197cf107-315b-411f-8216-2c5f9d056fe7",
				"f8624184-ad73-4b90-9050-9369f026713b",
				"0dfd2a26-ae3d-47a3-97b9-eb12219300e2",
				"4cfbc302-5edf-48ae-9979-c218621c38f3",
				"dd6c0b5b-73fa-43d6-943e-df1f232507e0",
				"3204774a-388d-4670-b4f6-3f4d8cbda0b4",
				"d7ab7274-9222-4168-ad6f-4a592fc3ae63",
				"becbd137-6e0e-467c-b8a5-d58ea3cf5f3e",
				"2b0f825c-3447-425a-b5e7-2a17a4eaf0ac",
				"e9ce67b8-1996-464c-b0e0-b568f1a8b31e",
				"a85449b0-ec9f-430b-9176-f8fd3ab5d29e",
				"26b5ddc5-266f-4ad5-83ef-97c726200b88",
				"8ee067f0-0e2b-4194-b7d2-2c5e43e3fa26",
				"20b45dc6-b49b-4d78-8481-e58d4359bbdd",
				"473d0ecd-242f-4ad7-8471-fde919ee11c8",
				"9f352640-af02-4254-bc92-64d0370f7e6c",
				"9f36533f-c56a-4561-bbbd-966bbd108843",
				"9370d681-7d39-423a-8bbb-1ab0bfb536c3",
				"327b6e20-71e2-4ff4-accd-f3d75b589c69",
				"66b34c7e-f8de-4e83-b434-411299aff1c7",
				"0d5e4187-7cbd-4681-9b5c-be01ac38551d",
				"9e46a24b-a71a-43cb-abe4-dcd84fd61316",
				"129041c9-28fe-4804-85d9-3c154698dfd6",
				"d0e36f0e-899e-4907-a934-5c6c53861b97",
				"ce135d23-65a8-44cf-8eb2-5cd8438775f9",
				"b1f67aa1-b525-4bd3-9bff-34a238899951",
				"933e8fa4-7a79-48e2-becc-f65e3d8fd6d2",
				"f5a398bf-d0ff-4555-9501-0a41a2536c6a",
				"0fb64de3-cdf1-4dba-9e05-0e107d5489a4",
				"6f811eaf-22cb-4b21-9ee2-922bd7dd43b5",
				"3c0a0031-7254-43e5-be50-337a1853506b",
				"67ae4421-e8df-4dc0-9456-7c91d5759409",
				"82a5d117-2a18-4a5f-bc48-222506a2f250",
				"cc0f3f51-118d-44fa-9ef1-7f0bf029caa6",
				"ea052624-cf47-41ba-afd1-72bcb5a3d605",
				"9dd4232d-6e2f-4e16-aa17-92df6d8f05d4"
			],
			"format": {
				"copied_from_pointer": {
					"id": "d6427946-1dc6-4531-9def-52b9ff20ff82",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"24433056-52d8-4171-a5b5-e354de717acf"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "72a6ab8e-c2e9-4dcc-b723-19f053f1beb1",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/palette\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5ec5be76-efc5-432d-9606-c0f77b247c89",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "083121be-fff4-4b9a-8eae-e980db6982be",
			"type": "text",
			"properties": {
				"title": [
					[
						"С помощью цвета дизайнеры создают структуру, управляют акцентами, предупреждают о важных действиях и кодируют контент. Чтобы палитра была идентична во всех продуктах, мы используем "
					],
					[
						"дизайн-токены",
						[
							[
								"a",
								"https://paradigm.mail.ru/design_tokens",
								true
							]
						]
					],
					[
						"."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5f301b0a-2c44-4205-8813-e095aa84d20b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b7d4eee9-afdb-40ee-bd87-391f3add4151",
			"type": "image",
			"properties": {
				"size": [
					[
						"191.0KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/77718f7b-990b-431c-9df6-5aa43b63c22e/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/77718f7b-990b-431c-9df6-5aa43b63c22e/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"file_ids": [
				"77718f7b-990b-431c-9df6-5aa43b63c22e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/b7d4eee9-afdb-40ee-bd87-391f3add4151.png"
		},
		{
			"id": "197cf107-315b-411f-8216-2c5f9d056fe7",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Палитра бренда"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "45233775-52a2-4ff9-bf17-16ebc2496b47",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f8624184-ad73-4b90-9050-9369f026713b",
			"type": "text",
			"properties": {
				"title": [
					[
						"Палитра бренда помогает в узнаваемости продуктов Mail. Она сохраняет преемственность в приёмах визуального языка и ассоциирует продукт с брендом компании. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c6665184-c4cd-470a-a5ef-ab47d56c238b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0dfd2a26-ae3d-47a3-97b9-eb12219300e2",
			"type": "text",
			"properties": {
				"title": [
					[
						"Основная палитра строиться вокруг нейтральной гаммы, основного синего цвета VK и акцентного зеленого. "
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4cfbc302-5edf-48ae-9979-c218621c38f3",
			"type": "text",
			"properties": {
				"title": [
					[
						"Дополнительная палитра используется для маскота Mail Байта. На банерах, всплывающих подсказках и других фонах Байта используется специально подобранный цвет.  "
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dd6c0b5b-73fa-43d6-943e-df1f232507e0",
			"type": "text",
			"properties": {
				"title": [
					[
						"В нейтральной палитре мы стараемся отказаться от чистых черного и белого цветов в пользу гаммы серого и графитового."
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3204774a-388d-4670-b4f6-3f4d8cbda0b4",
			"type": "image",
			"properties": {
				"size": [
					[
						"37.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/18def76b-f8f4-482f-90c2-00330066ce8d/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/18def76b-f8f4-482f-90c2-00330066ce8d/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.31868131868131866,
				"block_preserve_scale": true
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"file_ids": [
				"18def76b-f8f4-482f-90c2-00330066ce8d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/3204774a-388d-4670-b4f6-3f4d8cbda0b4.png"
		},
		{
			"id": "d7ab7274-9222-4168-ad6f-4a592fc3ae63",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Палитра внешних коммуникаций"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5de0c4f9-d920-474f-8b61-4133f9f4976f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "becbd137-6e0e-467c-b8a5-d58ea3cf5f3e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Основной цвет — фирменный синий. Акцентный зеленый занимает не более 40% палитры. Для имиджевых и охватных проектов стоит использовать эту пару."
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2b0f825c-3447-425a-b5e7-2a17a4eaf0ac",
			"type": "text",
			"properties": {
				"title": [
					[
						"Акцентный зеленый цвет не используется без синего. "
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e9ce67b8-1996-464c-b0e0-b568f1a8b31e",
			"type": "image",
			"properties": {
				"size": [
					[
						"19.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/35ee927d-fdba-413a-a004-57d1ebc0e706/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/35ee927d-fdba-413a-a004-57d1ebc0e706/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.24175824175824176,
				"block_preserve_scale": true
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"file_ids": [
				"35ee927d-fdba-413a-a004-57d1ebc0e706"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/e9ce67b8-1996-464c-b0e0-b568f1a8b31e.png"
		},
		{
			"id": "a85449b0-ec9f-430b-9176-f8fd3ab5d29e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Основную часть дополнительной палитры занимает нейтральная гамма, к которой в  добавляются второстепенные акцентные цвета в небольших количествах.  "
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "26b5ddc5-266f-4ad5-83ef-97c726200b88",
			"type": "image",
			"properties": {
				"size": [
					[
						"35.7KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2aec93d6-e141-4790-a9ce-31e54b95c0e8/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2aec93d6-e141-4790-a9ce-31e54b95c0e8/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.3282967032967033,
				"block_preserve_scale": true
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"file_ids": [
				"2aec93d6-e141-4790-a9ce-31e54b95c0e8"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/26b5ddc5-266f-4ad5-83ef-97c726200b88.png"
		},
		{
			"id": "8ee067f0-0e2b-4194-b7d2-2c5e43e3fa26",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Палитра внутренних коммуникаций"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d7ab7274-9222-4168-ad6f-4a592fc3ae63",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "20b45dc6-b49b-4d78-8481-e58d4359bbdd",
			"type": "text",
			"properties": {
				"title": [
					[
						"Акцентные цвета не могут занимать более 30% палитры коммуникации и используются только для второстепенных элементов."
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "473d0ecd-242f-4ad7-8471-fde919ee11c8",
			"type": "image",
			"properties": {
				"size": [
					[
						"20.3KB"
					]
				],
				"title": [
					[
						"image.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/7ce68608-f78b-4775-a9b1-ece12c754897/image.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/7ce68608-f78b-4775-a9b1-ece12c754897/image.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.24175824175824176,
				"block_preserve_scale": true
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"file_ids": [
				"7ce68608-f78b-4775-a9b1-ece12c754897"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/473d0ecd-242f-4ad7-8471-fde919ee11c8.png"
		},
		{
			"id": "9f352640-af02-4254-bc92-64d0370f7e6c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Дополнительную палитру можно использовать на баннерах, креативах, SMM-сообществах и презентациях."
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9f36533f-c56a-4561-bbbd-966bbd108843",
			"type": "text",
			"properties": {
				"title": [
					[
						"Во внешних рекламных кампаниях дополнительные цвета не участвуют."
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9370d681-7d39-423a-8bbb-1ab0bfb536c3",
			"type": "image",
			"properties": {
				"size": [
					[
						"19.1KB"
					]
				],
				"title": [
					[
						"image.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1e5ee7d3-6aca-4459-be05-4bdc29c3d606/image.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1e5ee7d3-6aca-4459-be05-4bdc29c3d606/image.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.3282967032967033,
				"block_preserve_scale": true
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"file_ids": [
				"1e5ee7d3-6aca-4459-be05-4bdc29c3d606"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/9370d681-7d39-423a-8bbb-1ab0bfb536c3.png"
		},
		{
			"id": "327b6e20-71e2-4ff4-accd-f3d75b589c69",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Палитра Байта"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8ee067f0-0e2b-4194-b7d2-2c5e43e3fa26",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "66b34c7e-f8de-4e83-b434-411299aff1c7",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для коммуникации с пользователем для маскота Mail Байта используется специально подобранный фон. Этот цвет используется как фон на котором размещен Байт. Может быть фоном баннера или всплывающего окна. "
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0d5e4187-7cbd-4681-9b5c-be01ac38551d",
			"type": "image",
			"properties": {
				"size": [
					[
						"403.9KB"
					]
				],
				"title": [
					[
						"image.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6f9dff5d-9bdb-4f84-9cbd-0b5b965eb6f8/image.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6f9dff5d-9bdb-4f84-9cbd-0b5b965eb6f8/image.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.6346153846153846,
				"block_preserve_scale": true
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"file_ids": [
				"6f9dff5d-9bdb-4f84-9cbd-0b5b965eb6f8"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/0d5e4187-7cbd-4681-9b5c-be01ac38551d.png"
		},
		{
			"id": "9e46a24b-a71a-43cb-abe4-dcd84fd61316",
			"type": "quote",
			"properties": {
				"title": [
					[
						"При наличии технической возможности допускается использование эффекта блюра для фона Байта. Токен с прозрачностью добавлен в общий репозиторий. "
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ea052624-cf47-41ba-afd1-72bcb5a3d605",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "129041c9-28fe-4804-85d9-3c154698dfd6",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Палитра для интерфейсов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "327b6e20-71e2-4ff4-accd-f3d75b589c69",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d0e36f0e-899e-4907-a934-5c6c53861b97",
			"type": "text",
			"properties": {
				"title": [
					[
						"Все цвета которые задействованы внутри наших интерефейсов занесены в общий репозиторий с токенами. Названия токенов синхронизированы с названиями VKUI. Это позволяет использовать одну компонентную базу регулируя токенами цвет."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4f9f071f-c921-4c5e-b0bd-23ade701b184",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ce135d23-65a8-44cf-8eb2-5cd8438775f9",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://vkcom.github.io/vkui-tokens/"
					]
				],
				"title": [
					[
						"VKUI Tokens documentation"
					]
				],
				"caption": [
					[
						"Токены для продуктов VK"
					]
				],
				"description": [
					[
						"Webpack React description"
					]
				]
			},
			"format": {
				"bookmark_icon": "https://vkcom.github.io/static/meta/favicon.ico",
				"copied_from_pointer": {
					"id": "7b9e0230-c542-429b-b1f8-32bd166139c3",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b1f67aa1-b525-4bd3-9bff-34a238899951",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы разделяем цвета на группы для удобной организации и поиска."
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "933e8fa4-7a79-48e2-becc-f65e3d8fd6d2",
			"type": "text",
			"properties": {
				"title": [
					[
						"Text – цвета которые используются для текста"
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f5a398bf-d0ff-4555-9501-0a41a2536c6a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Icon – цвета для иконок"
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0fb64de3-cdf1-4dba-9e05-0e107d5489a4",
			"type": "text",
			"properties": {
				"title": [
					[
						"Background – цвета для фонов и оттенки цветов"
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6f811eaf-22cb-4b21-9ee2-922bd7dd43b5",
			"type": "text",
			"properties": {
				"title": [
					[
						"Stroke – обводка элементов и контролов"
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3c0a0031-7254-43e5-be50-337a1853506b",
			"type": "text",
			"properties": {
				"title": [
					[
						"Pallete – палитра цветов которые не относятся к другим группам"
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "67ae4421-e8df-4dc0-9456-7c91d5759409",
			"type": "text",
			"properties": {
				"title": [
					[
						"Иногда цвета в группах повторяются. Это связано с перекраской компонентов в разных цветовых темах. Наша дизайн–система изначально поддерживает светлую и темную интерфейсные темы, поэтому количество базовых токенов большое."
					]
				]
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "82a5d117-2a18-4a5f-bc48-222506a2f250",
			"type": "image",
			"properties": {
				"size": [
					[
						"180.6KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3693e1df-d5b3-49c1-85d2-c145f8ae3663/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3693e1df-d5b3-49c1-85d2-c145f8ae3663/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1.5961538461538463,
				"block_preserve_scale": true
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"file_ids": [
				"3693e1df-d5b3-49c1-85d2-c145f8ae3663"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/82a5d117-2a18-4a5f-bc48-222506a2f250.png"
		},
		{
			"id": "cc0f3f51-118d-44fa-9ef1-7f0bf029caa6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Все цвета в зависимости от предназначения проверены на контрастность. Для текста и небольших элементов мы стараемся поддерживать контрастность на уровне АА. Вы можете заметить различия у акцентного цвета текста и фона, это как раз связано с настройками контрастности."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5ba2b484-460a-4afe-af25-bd265745b432",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ea052624-cf47-41ba-afd1-72bcb5a3d605",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Убедитесь, что коэффициент контрастности текста не ниже 3.0. Чем крупнее кегль текста, тем ниже коэффициент контрастности. Исключение — логотипы или декоративные элементы."
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "d2d6ce11-7663-49d0-aabb-66b90a200e3d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9dd4232d-6e2f-4e16-aa17-92df6d8f05d4",
			"type": "text",
			"parent_id": "ec15c567-4038-4c10-81bb-0a86aee56b08",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": []
}} />
);

export default NotionPalette;
